import React, { useState, Suspense, lazy } from 'react';
import styles from './InvestPage.module.css';

// Lazy load the tab components
const BondsList = lazy(() => import('./BondsList'));
const StocksList = lazy(() => import('./StocksList'));

const InvestPage = () => {
  const [activeTab, setActiveTab] = useState('bonds');

  // Tabs component for switching between Bonds and Stocks
  const renderTabs = () => (
    <div className={styles['tabs-container']}>
      <button
        onClick={() => setActiveTab('bonds')}
        className={`${styles['tab-button']} ${activeTab === 'bonds' ? styles['tab-button-active'] : ''}`}
      >
        Bonds
      </button>
      <button
        onClick={() => setActiveTab('stocks')}
        className={`${styles['tab-button']} ${activeTab === 'stocks' ? styles['tab-button-active'] : ''}`}
      >
        Stocks
      </button>
    </div>
  );

  // Loading fallback for Suspense
  const LoadingFallback = () => (
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
    </div>
  );

  return (
    <div className="pools-page-container">
      <div className="pools-content-wrapper">
        <h1>Investment Marketplace</h1>
        <div className="pools-description">
          Explore curated investment opportunities. Compare yields, issuers, and terms to find the best fit for your investment goals.
        </div>
        {renderTabs()}
        <Suspense fallback={<LoadingFallback />}>
          {activeTab === 'bonds' && <BondsList />}
          {activeTab === 'stocks' && <StocksList />}
        </Suspense>
      </div>
    </div>
  )
};

export default InvestPage;
